/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ArrowRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ArrowRight({
  children,
  viewPath = "/DesignSystem/Svgs/ArrowRight",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#B5B5B5"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ArrowRight.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-iaeGf': alignSelf,'--mt-2-iaeGf': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-iaeGf': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-iaeGf': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-iaeGf': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-iaeGf': opacity,'--w-7-iaeGf': typeof width === 'number' ? `${width}px` : width,'--h-8-iaeGf': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="ArrowRight.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M4.8 1.6L11.2 8l-6.4 6.4"
 style={{'--f-9-iaeGf': fill,'--s-10-iaeGf': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}